// 경로 상수 정의
export const ROUTES = {
  HOME: '/',
  SITE_INFORMATION: '/site-information',
  SITE_MANAGEMENT: '/site-management',
  USER_MANAGEMENT: '/user-management',
  RAW_DATA: '/raw-data',
  NOT_FOUND: '*',
} as const;

// Path 타입 정의 (상수에서 추출)
export type Path = (typeof ROUTES)[keyof typeof ROUTES];

// 네비게이션 가능한 경로만 (와일드카드 제외)
export type NavigatablePath = Exclude<Path, '*'>;
